import { Container, Grid, Link, Box } from '@mui/material';
import React from 'react';
import PricingScss from './Pricing.module.scss';
import OurCover from '../../Component/OurCover/OurCover';
import PricingComp from '../../Component/PricingComp/PricingComp';

function Pricing() {
    return (
        <div>
            <OurCover ourHead="Pricing" />
            {/* pricingPlan */}
            <PricingComp />
            {/* newsletter */}
            <section id={PricingScss.newsletter}>
                <Container maxWidth="lg">
                    <Grid container>
                        <Grid item xs={12} sm={9} md={6} sx={{ mx: 'auto' }}>
                            <Box className={PricingScss.newsletter}>
                                <h4 className={PricingScss.newsletterHead}>Join our newsletter</h4>
                                <form className={PricingScss.newsletterForm}>
                                    <Box className={PricingScss.newsletterFormItem}>
                                        <input type='email' placeholder='Enter your email'></input>
                                        <button type='submit'>learn more</button>
                                    </Box>
                                </form>
                                <Box className={PricingScss.newsletterFormBottom}>
                                    Already using Arcena? <Link href='#'>Sign in</Link> to your account
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </div>
    )
}

export default Pricing;
